import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RouteMasterService {

    constructor() {
    }

    routes = [

        {
            "db_value": "container_master",
            "urls": [
                "/dashboards/master-dashboard",
                "/master-data/container-master"
            ]
        },
        {
            "db_value": "depot_master",
            "urls": [
                "/dashboards/depot-dashboard",
                "/master-data/depot-master"
            ],
        },
        {
            "db_value": "user_master",
            "urls": [
                "/dashboards/user-dashboard",
                "/master-data/user-master"
            ],
        },
        {
            "db_value": "department_master",
            "urls": [
                "/dashboards/department-dashboard",
                "/master-data/department-master"
            ],
        },
        {
            "db_value": "role_master",
            "urls": [
                "/dashboards/role-dashboard",
                "/master-data/role-master"
            ],
        },
        {
            "db_value": "currency_master",
            "urls": [
                "/dashboards/currency-dashboard",
                "/master-data/currency-master"
            ],
        },
        {
            "db_value": "customer_master",
            "urls": [
                "/dashboards/customer-dashboard",
                "/master-data/customer-master"
            ],
        },
        {
            "db_value": "charge_master",
            "urls": [
                "/dashboards/charge-dashboard",
                "/master-data/charge-master"
            ],
        },
        {
            "db_value": "role_master",
            "urls": [
                "/dashboards/role-dashboard",
                "/master-data/role-master"
            ],
        },
        {
            "db_value": "region_master",
            "urls": [
                "/dashboards/region-dashboard",
                "/master-data/region-master"
            ],
        },
        {
            "db_value": "insurance_master",
            "urls": [
                "/one-way/insurance-master",
                "/master-data/insurance-master"
            ],
        },
        {
            "db_value": "request_processing",
            "urls": [
                "/one-way/request-processing",
                "/requests/request-processing"
            ],
        },
        {
            "db_value": "my_requests",
            "urls": [
                "/one-way/my-requests-dashboard",
                "/requests/my-requests"
            ],
        },
        {
            "db_value": "request",
            "urls": [
                "/one-way/request",
                "/requests/request-data"
            ],
        },
        {
            "db_value": "user_service_mapping",
            "urls": [
                "/dashboards/user-service-mapping-dashboard",
                "/master-data/user-service-mapping"
            ],
        },
        {
            "db_value": "role_master",
            "urls": [
                "/dashboards/master-dashboard",
                "/master-data/role-master"
            ]
        },
        {
            "db_value": "user_depot_access",
            "urls": [
                "/dashboards/user-depot-access-dashboard",
                "/master-data/user-depot-access"
            ],
        },
        // {
        //   "db_value": "mnr_dashboard",
        //   "urls": [
        //     "/dashboards/mnr-dashboard",
        //   ],
        // },
        {
            "db_value": "mnr_dashboard",
            "urls": [
                "/dashboards/mnr-dashboard",
                "/master-data/mnr-master"
            ],
        },
        {
            "db_value": "verify_customer",
            "urls": [
                "/verify-customer",
                "/verify-customer/leads",
                "/verify-customer/users",
            ],
        },
        {
            "db_value": "verify_customer_kyc",
            "urls": [
                "/verify-customer-kyc",
            ],
        },
        {
            "db_value": "create_leads",
            "urls": [
                "/create-leads",
            ],
        },
        {
            "db_value": "reports",
            "urls": [
                "/reports",
            ],
        },
        {
            "db_value": "tms_master",
            "urls": [
                "/dashboards/tms-dashboard",
                "/master-data/ticket-management"
            ],
        },
        {
            "db_value": "tms_suggestions",
            "urls": [
                "/apps/suggestions",
                // "/master-data/tms-master"
            ],
        },
        {
            "db_value": "invoice_workflow",
            "urls": [
                "/dashboards/invoice-approval",
                "/master-data/invoice-approval",
                "/master-data/invoice-approval-management",
            ],
        },
        {
            "db_value": "notes",
            "urls": [
                "/apps/notes",
            ],
        },
        {
            "db_value": "approval_management",
            "urls": [
                "/dashboards/approval-dashboard",
                "/master-data/approval-management-list"
            ],
        },
        {
            "db_value": "off_hire_containers",
            "urls": [
                "/off-hire-containers",
            ],
        },
        {
            "db_value": "ops_date_change",
            "urls": [
                "/ops-date-change",
            ],
        },
        {
            "db_value": "my_approvals",
            "urls": [
                "/dashboards/my-approvals",
                "/master-data/my-approval-list",
                "/master-data/approval-details"
            ],
        },
        {
            "db_value": "stock_report",
            "urls": [
                "/dashboards/stock-report",
            ],
        },
    ]

    always_allow_routes = {
        internal: [
            '/dashboards/dashboard1',
            // '/dashboards/arcon-dashboard',
            '/my-account',
            '/404',
            '/maintenance',
            '/client-dashboard/offers-for-you',
            '/client-dashboard/my-orders',
            '/web-request/lead-request/one-way-details',
            '/web-request/lead-request/trading-details',
            '/web-request/lead-request/lease-details',
            '/web-request/lead-request',
            '/authentication/login',
            '/authentication/register',
            '/authentication/forgotpassword',
            '/authentication/resetpassword',
            '/authentication/invite/setpassword',
            '/apps/chat',
            '/apps/suggestions',
            '/client-dashboard/company-profile',
            '/dashboards/tms-dashboard',
            "/master-data/ticket-management",
            "/apps/notes",
            "/download",
            "/dashboards/approval-dashboard",
            '/off-hire-containers',
            '/ops-date-change',
            "/dashboards/my-approvals",
        ],
        external: [
            // REMOVE comment after the page is implemented
            '/dashboards/dashboard1',
            // '/dashboards/arcon-dashboard',
            '/my-account',
            '/404',
            '/maintenance',
            '/client-dashboard/offers-for-you',
            '/client-dashboard/my-orders',
            '/web-request/lead-request/one-way-details',
            '/web-request/lead-request/trading-details',
            '/web-request/lead-request/lease-details',
            '/web-request/lead-request',
            '/authentication/login',
            '/authentication/register',
            '/authentication/forgotpassword',
            '/authentication/resetpassword',
            '/authentication/invite/setpassword',
            '/apps/chat',
            '/apps/suggestions',
            '/client-dashboard/company-profile',
            '/dashboards/tms-dashboard',
            "/master-data/ticket-management",
            "/apps/notes",
            "/download",
            "/dashboards/approval-dashboard",
            '/off-hire-containers',
            '/ops-date-change',
            "/dashboards/my-approvals",
        ]
    }

    getDBValueByUrl(url) {
        for (let idx = 0; idx < this.routes.length; idx++) {
            for (let jdx = 0; jdx < this.routes[idx].urls.length; jdx++) {
                if (this.routes[idx].urls[jdx] == url.substring(0, this.routes[idx].urls[jdx].length)) {
                    return this.routes[idx].db_value;
                }
            }
        }

        return null;
    }

    getUrlByDBValue(db_value) {
        for (let idx = 0; idx < this.routes.length; idx++) {
            if (this.routes[idx].db_value == db_value) {
                return this.routes[idx].urls[0];
            }
        }

        return null;
    }

    getUrlByDBValueOnLogin(db_value) {
        for (let idx = 0; idx < this.routes.length; idx++) {
            if (this.routes[idx].db_value == db_value) {
                return this.routes[idx].urls[1];
            }
        }

        return null;
    }
}
